import { Suspense, lazy } from 'react';
import { useRoutes } from 'react-router';
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => (
    <Suspense fallback={<></>}>
      <Component {...props} />
    </Suspense>
);

export default function Router() {

    return useRoutes([
        { path: "/", element: <></> },
        { path: "/content/carousel/:companyID/force", element: <CarouselCompany force="yes" /> },
        { path: "/content/carousel/:companyID", element: <CarouselCompany /> },

        { path: "/content/group-carousel/:groupID/force", element: <CarouselGroup force="yes" /> },
        { path: "/content/group-carousel/:groupID", element: <CarouselGroup /> },

        { path: "/content/review-tab/:companyID/force", element: <ReviewTabCompany force="yes" /> },
        { path: "/content/review-tab/:companyID", element: <ReviewTabCompany /> },

        { path: "/content/group-review-tab/:groupID/force", element: <ReviewTabGroup force="yes" /> },
        { path: "/content/group-review-tab/:groupID", element: <ReviewTabGroup /> },

        { path: "/content/review-feed/:companyID/force", element: <ReviewFeedCompany force="yes" /> },  
        { path: "/content/review-feed/:companyID", element: <ReviewFeedCompany /> },  

        { path: "/content/group-review-feed/:groupID/force", element: <ReviewFeedGroup force="yes" /> },
        { path: "/content/group-review-feed/:groupID", element: <ReviewFeedGroup /> },

        { path: "/content/floating-review-score/:companyID/force", element: <FloatingReviewScoreCompany force="yes" /> },
        { path: "/content/floating-review-score/:companyID", element: <FloatingReviewScoreCompany /> },

        { path: "/content/group-floating-review-score/:groupID/force", element: <FloatingReviewScoreGroup force="yes" /> },
        { path: "/content/group-floating-review-score/:groupID", element: <FloatingReviewScoreGroup /> },

        { path: "/content/widget/:companyID/force", element: <WidgetCompany force="yes" /> },
        { path: "/content/widget/:companyID", element: <WidgetCompany /> },

        { path: "/content/group-widget/:groupID/force", element: <WidgetGroup force="yes" /> },
        { path: "/content/group-widget/:groupID", element: <WidgetGroup /> },

        { path: "/content/online-form/:companyID/force", element: <OnlineForm force="yes" /> },
        { path: "/content/online-form/:companyID", element: <OnlineForm /> },
    ]);
}
  
const CarouselCompany = Loadable(lazy(() => import('./routes/carousel-company')));
const CarouselGroup = Loadable(lazy(() => import('./routes/carousel-group')));
const ReviewTabCompany = Loadable(lazy(() => import('./routes/tab-company')));
const ReviewTabGroup = Loadable(lazy(() => import('./routes/tab-group')));
const ReviewFeedCompany = Loadable(lazy(() => import('./routes/review-feed-company')));
const ReviewFeedGroup = Loadable(lazy(() => import('./routes/review-feed-group')));
const FloatingReviewScoreCompany = Loadable(lazy(() => import('./routes/floating-review-score-company')));
const FloatingReviewScoreGroup = Loadable(lazy(() => import('./routes/floating-review-score-group')));
const WidgetCompany = Loadable(lazy(() => import('./routes/widget-company')));
const WidgetGroup = Loadable(lazy(() => import('./routes/widget-group')));
const OnlineForm = Loadable(lazy(() => import('./routes/online-form')));

